module.exports = __webpack_public_path__ + "static/img/icon-treatpay.32f5eea.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-treatpay.png
// module id = enJE
// module chunks = 15